import {
  WM_CHANGE_SECTION,
  WM_CHANGE_MENU_SECTION,
  WM_CHANGE_WORKSHEET,
  WM_CHANGE_SLIDER_VISIBILITY,
  WM_INPUT_CHANGED,
  WM_INSERT_SPANISH_DISPLAYED,
  WM_INSERT_SPANISH,
  WM_UPDATE_CURSOR_POSITION,
  WM_TEACHING_TIPS_MODAL_VISIBLE,
  WM_RESET_INPUT_MAP
} from '../actions/action-types';
import { Sections } from '../../constants/sections';
import sections from '../static-data/get-sections-data';
import cloneDeep from 'lodash/cloneDeep';

const initialState = {
  currentSectionId: Sections.HOME,
  menuSectionId: Sections.HOME,
  currentWorksheetId: -1,
  currentWorksheetData: null,
  editedWorksheet: {
    worksheetId: 0,
    currentWorksheetInput: { 1: '' },
    formKey: 1,
    worksheetMap: {}
  },
  sections: sections,
  showSideMenuSlider: false,
  printSaveButtonActive: false,
  insertSpanishDisplayed: false,
  inputIndex: 0,
  cursorPosition: 0,
  teachingTipsModalVisible: false
};

const worksheetMaker = (state = initialState, action) => {
  switch (action.type) {
    case WM_CHANGE_SECTION: {
      return Object.assign({}, state, {
        currentSectionId: action.sectionId
      });
    }
    case WM_CHANGE_MENU_SECTION: {
      return Object.assign({}, state, {
        menuSectionId: action.menuSectionId,
        currentWorksheetId: -1
      });
    }
    case WM_CHANGE_WORKSHEET: {
      let worksheetDataObj = null;
      let worksheetData = [];
      let sectionData: any = state.sections.filter(item => item.id === state.currentSectionId)[0];

      if (sectionData && sectionData.worksheetList && sectionData.worksheetList.length > 0) {
        worksheetData = sectionData.worksheetList.filter(item => item.id === action.worksheetId);
        if (worksheetData && worksheetData.length > 0) {
          worksheetDataObj = worksheetData[0];
        }
      }

      return Object.assign({}, state, {
        currentWorksheetId: action.worksheetId,
        currentWorksheetData: cloneDeep(worksheetDataObj),
        editedWorksheet: {
          ...state.editedWorksheet,
          worksheetId: action.worksheetId
        },
        printSaveButtonActive: false
      });
    }
    case WM_CHANGE_SLIDER_VISIBILITY: {
      return Object.assign({}, state, {
        showSideMenuSlider: action.show
      });
    }
    case WM_INPUT_CHANGED: {
      const [[key]]: any = Object.entries(state.editedWorksheet.currentWorksheetInput);
      return {
        ...state,
        editedWorksheet: {
          ...state.editedWorksheet,
          worksheetId: action.worksheetId,
          currentWorksheetInput: {
            ...action.currentWorksheetInput
          },
          worksheetMap: {
            ...state.editedWorksheet.worksheetMap,
            ...action.currentWorksheetInput
          },
          formKey: key
        },
        printSaveButtonActive: true
      };
    }
    case WM_INSERT_SPANISH_DISPLAYED: {
      return {
        ...state,
        insertSpanishDisplayed: action.insertSpanishDisplayed
      };
    }

    case WM_INSERT_SPANISH: {
      const [[key, value]]: any = Object.entries(state.editedWorksheet.currentWorksheetInput);
      const start = value.slice(0, state.cursorPosition++);
      const end = value.slice(state.cursorPosition - 1, value.length);
      return {
        ...state,
        editedWorksheet: {
          ...state.editedWorksheet,
          currentWorksheetInput: {
            ...state.editedWorksheet.currentWorksheetInput,
            [key]: `${start}${action.specialChar}${end}`
          },
          worksheetMap: {
            ...state.editedWorksheet.worksheetMap,
            [key]: `${start}${action.specialChar}${end}`
          },
          formKey: key
        },
        insertSpanishDisplayed: false
      };
    }
    case WM_UPDATE_CURSOR_POSITION: {
      return {
        ...state,
        inputIndex: action.inputIndex,
        cursorPosition: action.cursorPosition
      };
    }
    case WM_TEACHING_TIPS_MODAL_VISIBLE: {
      return Object.assign({}, state, {
        teachingTipsModalVisible: action.visible
      });
    }
    case WM_RESET_INPUT_MAP: {
      return {
        ...state,
        editedWorksheet: initialState.editedWorksheet
      };
    }
    default: {
      return state;
    }
  }
};

export default worksheetMaker;
